import { ValidationError } from '@cian/peperrors/shared';
import { EFormFieldsNames } from '../types/requestForm';
import { isEnum } from './isEnum';
import { objectFromEntries } from './objectFromEntries';

/**
 * Хелпер, который автоматически мапит имя поля на field, так как он и так указан в field.name.
 * На выходе получим конфиг полей вида:
 * {
 *    [EFormFieldsNames.Name]: {
 *      field: NAME_QUESTION_FIELD,
 *      validation: yup.string(),
 *    },
 *    ...
 * }
 */
export function createFieldsConfig(entries) {
  return objectFromEntries(entries.map(function (entry) {
    return createSingleFieldConfig(entry);
  }));
}
export function createSingleFieldConfig(entry) {
  var name = entry.field.name;
  if (!isEnum(EFormFieldsNames)(name)) {
    throw new ValidationError({
      message: "\u041F\u043E\u043B\u0435 \u0444\u043E\u0440\u043C\u044B \"".concat(name, "\" \u043D\u0435 \u0431\u044B\u043B\u043E \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0441\u0440\u0435\u0434\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u043F\u043E\u043B\u0435\u0439 EFormFieldsNames"),
      domain: 'mappers.requestForm.fieldsConfig.createSingleFieldConfig'
    });
  }
  return [name, entry];
}